import React, { useState } from "react";
import "./Finder.css";
import "./VideoPlayer.css";

const videoFiles = [
  { name: "verbaudet 1.mp4", src: "/videos/video1.mp4", type: "video" },
  { name: "verbaudet 2.mp4", src: "/videos/video2.mp4", type: "video" },
  { name: "verbaudet 3.mp4", src: "/videos/video3.mp4", type: "video" },
  { 
    name: "Informations.txt", 
    type: "text",
    content: "Réalisation sonore complète pour Vertbaudet, musique, sound-design et mixage"
  }
];

export default function VideoFolder({ onClose, folderName }) {
  const [currentVideo, setCurrentVideo] = useState(null);
  const [showText, setShowText] = useState(false);
  const [textContent, setTextContent] = useState("");

  const openVideo = (video) => {
    setCurrentVideo(video);
  };

  const closeVideoPlayer = () => {
    setCurrentVideo(null);
  };

  const openTextFile = (content) => {
    setTextContent(content);
    setShowText(true);
  };

  const closeTextFile = () => {
    setShowText(false);
  };

  return (
    <>
      <div className="finder-overlay" onClick={onClose}>
        <div className="finder-window" onClick={(e) => e.stopPropagation()}>
          <div className="finder-topbar">
            <div className="finder-buttons">
              <span className="close" onClick={onClose}></span>
              <span className="minimize"></span>
              <span className="maximize"></span>
            </div>
            <span className="finder-title">{folderName}</span>
          </div>
          <div className="finder-content">
            {videoFiles.map((file, index) => (
              <div 
                key={index} 
                className="finder-file" 
                onClick={() => file.type === "video" ? openVideo(file) : openTextFile(file.content)}
              >
                <img 
                  src={file.type === "video" ? "/mp4.png" : "/txt.png"} 
                  alt={file.name} 
                />
                <span>{file.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {currentVideo && (
        <div className="video-player-overlay" onClick={closeVideoPlayer}>
          <div className="video-player-window" onClick={(e) => e.stopPropagation()}>
            <div className="video-player-topbar">
              <div className="video-player-buttons">
                <span className="close" onClick={closeVideoPlayer}></span>
                <span className="minimize"></span>
                <span className="maximize"></span>
              </div>
              <span className="video-player-title">{currentVideo.name}</span>
            </div>
            <div className="video-player-content">
              <video controls autoPlay>
                <source src={currentVideo.src} type="video/mp4" />
              </video>
            </div>
          </div>
        </div>
      )}

      {showText && (
        <div className="text-overlay" onClick={closeTextFile}>
          <div className="text-window" onClick={(e) => e.stopPropagation()}>
            <div className="text-topbar">
              <div className="text-buttons">
                <span className="close" onClick={closeTextFile}></span>
                <span className="minimize"></span>
                <span className="maximize"></span>
              </div>
              <span className="text-title">Informations.txt</span>
            </div>
            <div className="text-content">
              <p>{textContent}</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
